import config from '../../config'
import trackers from './scripts'

export const enabledTrackers = Object.keys(config.tracker)
  .map(key => trackers[key] && { ...trackers[key], key })
  .filter(tracker => tracker)

export function trackForAll(payload) {
  enabledTrackers.forEach(tracker => {
    tracker.track(config.tracker[tracker.key], payload)
  })
}

export function trackFor(payloads) {
  Object.keys(payloads).forEach(k => {
    if (!trackers[k]) return

    trackers[k].track(config.tracker[k], payloads[k])
  })
}

const countryNameToCodeMap = {
  India: 'IN',
  Indonesia: 'ID',
  Malaysia: 'MY',
  Philippines: 'PH',
  Singapore: 'SG',
  Thailand: 'TH',
  Vietnam: 'VN',
}

export function getClientCountry(countryName) {
  if (!countryName) return 'ID'

  return countryNameToCodeMap[countryName] || 'ID'
}

export function getClientCurrency() {
  return 'IDR'
}

// ref: https://www.geeksforgeeks.org/detect-the-operating-system-of-user-using-javascript/
export function getClientInterface() {
  if (!navigator || !navigator.userAgent) return 'Unknown'

  if (navigator.userAgent.indexOf('Win') != -1) return 'Windows'
  if (navigator.userAgent.indexOf('Mac') != -1) return 'Mac'
  if (navigator.userAgent.indexOf('Linux') != -1) return 'Linux'
  if (navigator.userAgent.indexOf('Android') != -1) return 'Android'
  if (navigator.userAgent.indexOf('like Mac') != -1) return 'iOS'

  return 'Others'
}

export function getClientLanguage() {
  return 'en'
}
